"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResponse = void 0;
/**
 * Contains the response of an API call. Either holds the generic result object or the error message.
 */
class ApiResponse {
    constructor(data, error) {
        this._data = data;
        this._error = error;
    }
    /**
     * @returns <code>true</code> if an error occurred. The error data can be found in <code>response.error</code>.
     */
    isError() {
        return this._error !== undefined;
    }
    /**
     * @returns the response data or <code>undefined</code> if an error occurred.
     */
    get data() {
        return this._data;
    }
    /**
     * @returns the error data or <code>undefined</code> if the request was successful.
     */
    get error() {
        return this._error;
    }
}
exports.ApiResponse = ApiResponse;
//# sourceMappingURL=ApiResponse.js.map